import {Component, Input} from '@angular/core';
import {DcpAuthService} from '@app/auth/services/dcp-auth.service';
import {CrmAccountTrackingService} from '@app/services/crm-account-tracking.service';
import {TransactionListCta, TransactionType} from '@dcp/configurator';
import {LaunchDialogService} from '@spartacus/storefront';
import {BehaviorSubject} from 'rxjs';
import {LeadFormCreator} from '../lead-form.model';

@Component({
  selector: 'dcp-lead-form-user-status',
  templateUrl: './lead-form-user-status.component.html',
  styleUrls: ['./lead-form-user-status.component.scss']
})
export class LeadFormUserStatusComponent {

  @Input() transactionType: TransactionType;
  @Input() transactionListCta: TransactionListCta;
  @Input() user: LeadFormCreator;
  @Input() sapEmployeeSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
    public authService: DcpAuthService,
    private crmAccountTrackingService: CrmAccountTrackingService,
    public launchDialogService: LaunchDialogService,
  ) {
  }

  /**
   * Clearing all data from the session.
   */
  clearAllData() {
    this.crmAccountTrackingService.clearAllData();
  }

}
